import React, { useEffect, useState } from "react"
import axios from "axios"
import { useNavigate } from "react-router-dom"
import baseURL from "../Url/Url.jsx"
import SideBarAdmin from "../Layout/SideBarAdmin.jsx";

const AdminDashboard = () => {
    const navigate = useNavigate()

    const [totalData, setTotalData] = useState(0)
    const [totalPerusahaan, setTotalPerusahaan] = useState(0)
    const [totalUsers, setTotalUsers] = useState(0)
    const [totalPerhitungan, setTotalPerhitungan] = useState(0)
    const [totalKaryawan, setTotalKaryawan] = useState(0)

    useEffect(() => {
        const checkAdmin = async () => {
            try {
                await axios.get(`${baseURL}/admin/users`, {
                    withCredentials: true
                })
                getUsers()
                getTotalPerhitungan()
                getTotalKaryawan()
                getTotalData()
            } catch (error) {
                console.log("Bukan admin / session habis")
                window.location.href = "/adm13n"
            }
        }
        checkAdmin()
    }, [])    

    const getUsers = async () => {
        const res = await axios.get(`${baseURL}/admin/users`)
        const mapped = res.data.map(u => ({
            ...u,
            password: "",
            confPassword: ""
        }))
        const uniquePerusahaan = new Set(
            mapped
                .map(u => u.perusahaan)
                .filter(p => p !== null && p !== undefined && p !== "")
        )
        setTotalUsers(mapped.length)
        setTotalPerusahaan(uniquePerusahaan.size)
    }

    const getTotalPerhitungan = async () => {
        const [tetapRes, tidakTetapRes] = await Promise.all([
            axios.get(`${baseURL}/admin/pphBulanIniTetap`),
            axios.get(`${baseURL}/admin/pphBulanIniTidakTetap`)
        ])
    
        const total =
            (tetapRes.data?.totalPphBulanIni || 0) +
            (tidakTetapRes.data?.totalPphBulanIni || 0)
    
        setTotalPerhitungan(total)
    }

    const getTotalKaryawan = async () => {
        const [tetapRes, tidakTetapRes] = await Promise.all([
            axios.get(`${baseURL}/admin/karyawanTetapAdmin`),
            axios.get(`${baseURL}/admin/karyawanTidakTetapAdmin`)
        ])
    
        // gabungkan dua array
        const allKaryawan = [
            ...(tetapRes.data || []),
            ...(tidakTetapRes.data || [])
        ]
    
        // ambil KTP unik (abaikan null / kosong)
        const ktpSet = new Set(
            allKaryawan
                .map(k => k.ktp)      // ganti kalau nama field beda
                .filter(Boolean)      // buang null, undefined, ""
        )
    
        setTotalKaryawan(ktpSet.size)
    }

    const getTotalData = async () => {
        const [
            perhitunganTetapRes,
            perhitunganTidakTetapRes,
            karyawanTetapRes,
            karyawanTidakTetapRes,
            users
        ] = await Promise.all([
            axios.get(`${baseURL}/admin/perhitunganTetapAdmin`),
            axios.get(`${baseURL}/admin/perhitunganTidakTetapAdmin`),
            axios.get(`${baseURL}/admin/karyawanTetapAdmin`),
            axios.get(`${baseURL}/admin/karyawanTidakTetapAdmin`),
            axios.get(`${baseURL}/admin/users`)
        ])
    
        const total =
            (perhitunganTetapRes.data?.length || 0) +
            (perhitunganTidakTetapRes.data?.length || 0) +
            (karyawanTetapRes.data?.length || 0) +
            (karyawanTidakTetapRes.data?.length || 0)+
            (users.data?.length || 0)
    
        setTotalData(total)
    }
    
    

    const logout = async () => {
        await axios.delete(`${baseURL}/logoutBE`)
        navigate("/adm13n", { replace: true })
    }

    return (
        <div id="wrapper">
            {/* SIDEBAR ADMIN */}
            <SideBarAdmin/>
            {/* CONTENT */}
            <div id="content-wrapper">
                {/* NAVBAR */}
                <nav className="navbar navbar-expand-sm sticky-top nav-bar py-3">
                    <div className="container">
                        <h5 className="fw-bold m-0">Admin Dashboard</h5>
                        <button onClick={logout} className="btn btn-logout">
                            <i className="bi bi-power"></i>
                        </button>
                    </div>
                </nav>
                {/* KONTEN */}
                <div className="container-fluid mt-5">
                    <h4 className="text-center fw-bold mb-4 pb-2">
                        Selamat Datang Admin
                    </h4>
                    <div className="row justify-content-center px-3">
                        <div className="col-md-4 mb-3">
                            <div className="box p-4 text-center">
                                <i className="bi bi-person-check fs-1"style={{color:"rgb(123, 0, 238)"}}></i>
                                <h1 className="fw-bold">{totalUsers}</h1>
                                <h6>Total User</h6>
                            </div>
                        </div>
                        <div className="col-md-4 mb-3">
                            <div className="box p-4 text-center">
                                <i className="bi bi-buildings fs-1"style={{color:"rgb(181, 84, 0)"}}></i>
                                <h1 className="fw-bold">{totalPerusahaan}</h1>
                                <h6>Total Perusahaan</h6>
                            </div>
                        </div>
                        <div className="col-md-4 mb-3">
                            <div className="box p-4 text-center">
                                <i className="bi bi-people fs-1"style={{color:"rgb(0, 181, 198)"}}></i>
                                <h1 className="fw-bold">{totalKaryawan}</h1>
                                <h6>Total Karyawan</h6>
                            </div>
                        </div>
                        <div className="col-md-4 mb-3">
                            <div className="box p-4 text-center">
                                <i className="bi bi-database fs-1"style={{color:"rgb(0, 85, 232)"}}></i>
                                <h1 className="fw-bold">{totalData}</h1>
                                <h6>Total Data</h6>
                            </div>
                        </div>
                        <div className="col-md-8 mb-3">
                            <div className="box p-4 text-center">
                                <i className="bi bi-cash-stack fs-1"style={{color:"rgb(12, 219, 1)"}}></i>
                                <h1 className="fw-bold">
                                    {new Intl.NumberFormat('id-ID', {
                                        style: 'currency',
                                        currency: 'IDR',
                                        minimumFractionDigits: 0
                                    }).format(totalPerhitungan || 0)}
                                </h1>
                                <h6>Total PPH</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AdminDashboard
